<template>
  <div id="wish-modal" class="surface-post-expanded" @keydown="onKeyboardNavigation">
    <div v-if="postCid" class="wish-modal-toolbar">
      <div class="index" v-text="postIndex + 1 + '/' + totalPosts" />
      <div class="nav-buttons">
        <button :disabled="isFirst" class="first" @click="goToFirst">
          <base-icon name="first_page" size="small" :alt="__('First')" :title="__('First')" />
        </button>
        <button :disabled="isFirst" class="previous" @click="goToPrevious">
          <base-icon name="navigate_before" :alt="__('Previous')" :title="__('Previous')" />
        </button>
        <button :disabled="isLast" class="next" @click="goToNext">
          <base-icon name="navigate_next" :alt="__('Next')" :title="__('Next')" />
        </button>
        <button :disabled="isLast" class="last" @click="goToLast">
          <base-icon name="last_page" size="small" :alt="__('Last')" :title="__('Last')" />
        </button>
      </div>
      <div class="close-button">
        <button class="close" @click="cancel">
          <base-icon name="close" :alt="__('Close')" :title="__('Close')" />
        </button>
      </div>
    </div>
    <div class="wish-modal-popup">
      <iframe class="wish-modal-content-frame" :src="frameSrc" />
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import BaseIcon from 'vuecomponents/base_icon'
import ModalMixin from 'vuemixins/modal_mixin'
import { mapState, mapGetters, mapActions } from 'vuex'

const RIGHT_KEY = 39
const LEFT_KEY = 37

export default {
  components: { BaseIcon },
  mixins: [ModalMixin],
  props: {
    postCid: {
      type: String,
      default: null,
      validator: (c) => c.startsWith('c'),
    },
  },
  computed: {
    ...mapGetters('post', ['sortedPosts']),
    ...mapGetters('postAction', ['expandedPostFrameUrl']),
    ...mapGetters(['format']),
    postIndex() {
      return this.sortedPosts.findIndex((p) => p.cid === this.postCid)
    },
    totalPosts() {
      return this.sortedPosts.length
    },
    isFirst() {
      return this.postIndex === 0
    },
    isLast() {
      return this.postIndex === this.totalPosts - 1
    },
    frameSrc() {
      return this.expandedPostFrameUrl
    },
  },
  mounted() {
    window.addEventListener('keydown', this.onKeyboardNavigation)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyboardNavigation)
  },
  methods: {
    ...mapActions('postAction', ['expandPost', 'unexpandPost']),
    onKeyboardNavigation(e) {
      if (e.keyCode === RIGHT_KEY && !this.isLast) {
        this.goToNext()
      } else if (e.keyCode === LEFT_KEY && !this.isFirst) {
        this.goToPrevious()
      }
    },
    goToFirst() {
      this.expandPost({ postCid: this.sortedPosts[0].cid })
    },
    goToPrevious() {
      this.expandPost({ postCid: this.sortedPosts[this.postIndex - 1].cid })
    },
    goToNext() {
      this.expandPost({ postCid: this.sortedPosts[this.postIndex + 1].cid })
    },
    goToLast() {
      this.expandPost({ postCid: this.sortedPosts[this.totalPosts - 1].cid })
    },
    cancel() {
      this.unexpandPost()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/3/modules/all';

.nav-buttons,
.close-button {
  button {
    color: white;
  }
}

#wish-modal {
  position: fixed;
  width: 100vw;
  @include vh100;
  top: 0;
  left: 0;
  background: linear-gradient(rgba(#333, 0.9), rgba(#333, 0.5));
  z-index: 1000000;

  .wish-modal-toolbar {
    padding: 0 10px;
    height: 44px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: white;

    .index {
      font-size: 12px/12px;
      font-weight: 300;
      width: 20%;
    }

    .close-button {
      width: 20%;
      text-align: right;
    }

    button {
      border: none;
      background: none;
      padding: 0;
      margin: 0;
      width: 40px;
      height: 40px;

      &:disabled {
        opacity: 0.1;
      }

      img {
        vertical-align: middle;
      }
    }

    button.next {
      margin-left: 11px;
    }
  }

  .wish-modal-popup {
    position: absolute;
    width: 720px;
    height: 90vh;
    top: 0;
    left: 50%;
    margin-left: -360px;
    border-top: 4px solid rgba(white, 0.98);
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    background: rgba(white, 0.98);
    display: flex;
    overflow: auto !important;
    -webkit-overflow-scrolling: touch !important;

    > iframe {
      width: 100%;
      height: 90vh;
    }

    @media (max-width: 720px) {
      width: 100vw;
      margin: 10vh 0 0 0;
      left: 0;
      //height: 100vh;
      flex-direction: column;
    }

    @media (min-width: 721px) {
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
      margin-top: calc(10vh - 4px);
      margin-bottom: 0;
      flex-direction: column;
    }
  }
}
</style>
